import React, { useEffect } from "react";
import "../../index.css";
import logo from '../../assets/img/logo.webp';

// Importar los componentes
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import WhatsAppButton from "./WhatsAppButton";

function Header() {

  return (
    <div>
      {/* Componentes importados */}
      <Topbar logo={logo} />
      <Navbar />
      <WhatsAppButton course={null} />
    </div>
  );
}

export default Header;
